import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { Alert, Modal, Button, Tooltip, message, Upload, Form, Tabs } from 'antd';
import { useParams, useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import Loader from 'src/components/loader.component';
import { validations } from 'src/utils/custom.validator';
import CardHistory from './cardHistory';
import CardViewTransactionGrid from './cardTransactions';
import apiCalls from 'src/api/apiCalls';
import ComponentsBreadcrumb from 'src/layout/componentsBreadcrumb';
const UPLOAD_API_END_POINT = process.env.REACT_APP_API_END_POINT + '/UploadFile';
import defaultCard from "../../../../assets/images/default-card.png"
import { badge } from 'src/utils/statusColorsCode';

// Sets for efficient action name lookups
const FREEZE_RELATED_NAMES = new Set(["Freeze/Unfreeze", "Unfreeze", "Freeze", "freezed"]);
const PENDING_FREEZE_NAMES_LOWER = new Set(['freeze pending', 'unfreeze pending']);
const OTHER_ACTION_NAMES = new Set(["Report Loss", "Resend Pin", "Replace Card"]);

const CardsDetailView = (props) => {
    const navigate = useNavigate()
    const [details, setDetails] = useState(null);
    const [errorMsg, setErrorMsg] = useState(null);
    const [loader, setLoader] = useState(false);
    const [freeze, setFreeze] = useState();
    const cardDivRef = React.useRef(null);
    const [visible, setVisible] = useState(false);
    const [fileLists, setFileLists] = useState({ SignImage: [] });
    const [form] = Form.useForm();
    const { id, cardId, type } = useParams();
    const [isShowcardModal, setIsShowcardModal] = useState()
    const [isBtnLoader, setIsBtnLoader] = useState()
    const [actionName, setActionName] = useState()
    const [cardDetailactions, setCardDetailactions] = useState()
    const [actionsErrorMsg, setActionsErrorMsg] = useState()
    const [uploadError, setUploadError] = useState();
    const tabs = [{ key: 1, name: 'Transactions' }, { key: 2, name: 'Card Activity' }];
    const [selectedTab, setSelectedTab] = useState('1');
    const actions = {
        "name": "Cards",
        "isEnabled": true,
        "icon": null,
        "actions": [
            {
                "name": "View",
                "isEnabled": true,
                "icon": ""
            },
            {
                "name": "Freeze/Unfreeze",
                "isEnabled": true,
                "icon": ""
            }
        ]
    }
    const [uploadRules, setUploadRules] = useState({ freezeSignImage: details?.needSignforFreezeCard, setPinSignImage: details?.cardSetPinNeedSign })
    useEffect(() => {
        if (id && cardId) {
            getCardDetails();
        }
    }, [id, cardId])
    const updateCardState = (response) => {
        setDetails(response.data);
        setFreeze(!(response.data?.state == "Freeze" || response.data?.state?.toLowerCase() == "freezed"));
        setUploadRules({ freezeSignImage: response?.data?.needSignforFreezeCard });
    };

    const updateCardActions = (response) => {
        const isFreezeState = response.data?.state == "Freeze" || 
                            response.data?.state?.toLowerCase() == "freezed" || 
                            response.data?.state?.toLowerCase() == 'freeze pending';
        
        if (response?.data?.state == 'Freeze' || 
            response?.data?.state == 'UnFreeze' || 
            response.data?.state?.toLowerCase() == "freezed" || 
            response?.data?.state == 'UnFreezed' || 
            response?.data?.state?.toLowerCase() == 'freeze pending' || 
            response?.data?.state?.toLowerCase() == 'unfreeze pending') {
            setCardDetailactions(showHideActions(actions?.actions, isFreezeState));
        }
    };

    const getCardDetails = async () => {
        setLoader(true);
        setCardDetailactions(actions?.actions);
        
        let response = await apiCalls.cardViewDetails(id, cardId);
        
        if (response.ok) {
            updateCardState(response);
            updateCardActions(response);
        } else {
            setErrorMsg(apiCalls.isErrorDispaly(response));
        }
        
        setLoader(false);
    }
    const showHideActions = (detailactions, actionState) => {
        // 'type' is available from the outer scope (useParams)
        return detailactions?.map(obj => {
            const objectNameLower = obj.name?.toLowerCase();

            // Handle freeze/unfreeze related actions
            if (FREEZE_RELATED_NAMES.has(obj.name) || (objectNameLower && PENDING_FREEZE_NAMES_LOWER.has(objectNameLower))) {
                return { ...obj, name: actionState ? 'Unfreeze' : 'Freeze' };
            } 
            // Handle other specific actions like Report Loss, Resend Pin, Replace Card
            else if (OTHER_ACTION_NAMES.has(obj.name)) {
                let isEnabledTarget = !actionState; // Default: enabled if card is not in a frozen/actionState
                // Specific rule for "Resend Pin" on "Virtual" cards
                if (obj.name === "Resend Pin" && type === 'Virtual') {
                    isEnabledTarget = false;
                }
                return { ...obj, isEnabled: isEnabledTarget };
            }
            return obj;
        });
    }
    const navigateToCards = useCallback(() => {
        navigate(`/customer/${id}/customerCards`)
    }, [])
    const onActionClick = (key) => {
        const actions = {
            "Freeze/Unfreeze": () => showModal(key), "Unfreeze": () => showModal(key), 'Freeze': () => showModal(key),
            'Report Loss': () => handleActions(key),
            'Replace Card': () => handleActions(key),
            'Resend Pin': () => handleActions(key), Deposit: () => showModal(key)
        }
        actions?.[key]();
    }
    const handleActions = (key) => {
        if ((details?.state == "Approved" || details?.state == "Active" || details?.state?.toLowerCase() == "freezed" || details?.state == "Freeze" || details?.state?.toLowerCase() == 'freeze pending' || details?.state?.toLowerCase() == 'unfreeze pending') && details?.state != "Pending") {
            setIsShowcardModal(true); setActionName(key); setActionsErrorMsg(null)
        } else {
            setErrorMsg(`Only approved card can ${key}`);
        }
    }
    const freezeCard = async () => {
        setErrorMsg(null)
        setLoader(true);
        let action = { "Freeze/Unfreeze": 'Freezed', Freeze: 'Freezed', Unfreeze: 'UnFreezed' }
        let obj = { "id": cardId, "status": 1, "actionBy": action[actionName], CreatedBy: props.user?.userName, CreatedDate: new Date(), "signImage": fileLists?.SignImage[0]?.response[0] }
        let response = await apiCalls.freezeunfreezeCard(id, cardId, obj)
        if (response.ok) {
            message.success({
                content: `Card ${action[actionName]} successfully!`,
                className: "custom-msg",
                duration: 3,
            });
            setErrorMsg(null)
            setVisible(false);
            setUploadError(null)
            setFreeze(!freeze);
            setLoader(false); setCardDetailactions(showHideActions(cardDetailactions, freeze))
            getCardDetails();
            setFileLists({ SignImage: [] });
            form.resetFields()
        }
        else {
            setErrorMsg(apiCalls.isErrorDispaly(response));
            setUploadError(null)
            cardDivRef?.current?.scrollIntoView(0, 0);
            setLoader(false);
            setVisible(false);
            setUploadRules({ freezeSignImage: details?.needSignforFreezeCard })
            setFileLists({ SignImage: [] });
            form.resetFields()
        }
    }
    const showModal = (key) => {
        if (!details?.isFreezEnable) {
            setErrorMsg(`Please contact administrator for freeze / unfreeze`);
        } else {
            if ((details?.state == "Approved" || details?.state == "Active" || details?.state?.toLowerCase() == "freezed" || details?.state == "Freeze" || details?.state.toLowerCase() == 'freeze pending' || details?.state.toLowerCase() == 'unfreeze pending') && details?.state != "Pending") {
                setErrorMsg(null)
                setVisible(true); setActionName(key);
            } else {
                setErrorMsg("Only approved card can freeze");
            }
        }
    };
    const handleCancel = useCallback(() => {
        setErrorMsg(null);
        setUploadError(null);
        setVisible(false);
        setFileLists({ SignImage: [] });
        setUploadRules({ freezeSignImage: details?.needSignforFreezeCard });
        form.resetFields();
    }, [details?.needSignforFreezeCard, form]);

    const cancelcardActions = useCallback(() => {
        setIsShowcardModal(false)
    }, [])

    const handlecardActions = useCallback(async () => {
        setActionsErrorMsg(null);
        setIsBtnLoader(true);
        try {
            let obj = {
                id: cardId,
                status: 1,
                actionBy: actionName,
                CreatedBy: props.user?.userName,
                CreatedDate: new Date(),
            };
            let response = await apiCalls.saveActions(obj, id);
            let actionMsgs = {
                "Report Loss": "Card loss reported successfully",
                "Replace Card": "Card replacement requested successfully",
                "Resend Pin": "Pin resent successfully",
            };
            if (response.ok) {
                message.success({
                    content: actionMsgs[actionName],
                    className: "custom-msg",
                    duration: 3,
                });
                setIsShowcardModal(false);
                setActionsErrorMsg(null);
            } else {
                setActionsErrorMsg(apiCalls.isErrorDispaly(response));
            }
        } catch (error) {
            setActionsErrorMsg(error);
        } finally {
            setIsBtnLoader(false);
        }
    }, [cardId, actionName, id, props.user?.userName]);

    const handleUploadChange = useCallback((type, { fileList }) => {
        setUploadError(null);
        const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

        if (fileList[0]?.size > MAX_FILE_SIZE) {
            setUploadError('File size cannot exceed 2MB.');
            return;
        }

        const fileName = fileList[0]?.name;
        const fileNameParts = fileName?.split('.');
        if (fileNameParts?.length > 2) {
            setUploadError("File doesn't allow double extension");
            return;
        }

        const fileExtension = fileNameParts?.length > 1 ? fileNameParts[fileNameParts.length - 1].toLowerCase() : '';
        const allowedExtensions = ['png', 'jpg', 'jpeg'];

        if (fileExtension && !allowedExtensions.includes(fileExtension)) {
            setUploadError('Only PNG, JPG, and JPEG files are allowed.');
            return;
        }

        setFileLists((prevFileLists) => ({ ...prevFileLists, [type]: fileList }));

        if (fileList.length > 0) {
            form.setFields([{ name: type, errors: [] }]);
        }

        const latestFile = fileList[fileList.length - 1];

        if (latestFile && latestFile.status === 'done') {
            message.success('Upload successful!');
            setUploadRules({ freezeSignImage: false });

            const imageUrl = latestFile.response?.url || URL.createObjectURL(latestFile.originFileObj);
            form.setFieldsValue({ [type]: imageUrl });

            setFileLists((prevFileLists) => ({
                ...prevFileLists,
                [type]: [...fileList],
            }));
        }
    }, [form]);
    const handleRemove = useCallback((type) => () => {
        form.setFieldsValue({ [type]: null });
        setFileLists((prevFileLists) => ({
            ...prevFileLists,
            [type]: [],
        }));
        setUploadError(null);
        setUploadRules({ freezeSignImage: details?.needSignforFreezeCard })
    })
    const handleTabs = useCallback((key) => {
        setSelectedTab(key)
    }, [])

    const breadCrumbList = useMemo(() => [
        { id: '1', bname: 'Cards', url: `/customer/${id}/customerCards` },
        { id: '2', bname: details?.cardName },
    ], [details]);

   const closeError=useCallback(()=>{
    setErrorMsg(null)
   },[])

   const closeUploadError=useCallback(()=>{
    setUploadError(null)
   },[])

   const freezCardActionHandler=useCallback(()=>{
        form.validateFields()
            .then(() => {
                freezeCard();
            })
            .catch((errorInfo) => {
                console.log('Validation Failed:', errorInfo);
            });
   },[])

    return (
        <>
         <div className='mb-8'>
              <ComponentsBreadcrumb breadCrumbList={breadCrumbList} />
          </div>
            {loader && <Loader />}
            {!loader && <>
                <div ref={cardDivRef}></div>
                {errorMsg !== undefined && errorMsg !== null && (
                    <div className='mb-4'>
                        <Alert
                            className='mb-6'
                            type="error"
                            description={errorMsg}
                            onClose={closeError}
                            showIcon
                            closable
                        />
                    </div>
                )}
                <div className=''>
                <div className=''>
                        {(details?.state?.toLowerCase() == "active"|| details?.state?.toLowerCase() =="approved"|| details?.state?.toLowerCase() == "freezed") &&
                            <ul className="mb-2 flex justify-end text-end md:w-[380px] mx-auto">
                                {cardDetailactions?.map(action => (
                                    action?.isEnabled && action?.name != 'View' && (
                                        <li key={action.name} className={`cursor-pointer ${details?.state?.toLowerCase() == "pending" ? 'actionsdisabled' : ''}`} onClick={() => ((details?.state?.toLowerCase() === "freeze pending" && action?.name?.toLowerCase() === 'unfreeze') || (details?.state?.toLowerCase() === "unfreeze pending" && action?.name?.toLowerCase() === 'freeze')) ? '' : onActionClick(action?.name)}>
                                            <Tooltip title={action?.name === "Freeze/Unfreeze" ? "Freeze" : action?.name} key={action?.name === "Freeze/Unfreeze" ? "Freeze" : action?.name}>
                                                <div className='c-pointer'><span
                                                    className={`icon md c-pointer  ${(action?.name === "Freeze/Unfreeze" || action?.name === "Unfreeze") ? "freeze" : action?.name}`}
                                                ></span> </div> </Tooltip>
                                        </li>
                                    )
                                ))}
                            </ul>
                        }
                            </div>
                    {details != null &&
                        <>
                            <div
                                className={`${details?.type?.type == 'Physical' ? 'physical-bg' : 'virtual-bg'} mb-4`}
                            >
                                <div className='md:w-[380px] mx-auto'>
                                    <div className='mb-0 relative w-full h-full mx-auto'>
                                        <img src={details?.logo || defaultCard} className='w-full h-full object-cover mx-auto rounded-2xl'></img>
                                        <div className="virtual-badge mb-4">{details?.type}</div>
                                        <div className='absolute top-0 left-0 h-full w-full p-4 flex flex-col justify-between'>
                                            <div className=' gap-3'>
                                            </div>
                                            <div className=''>
                                                <p className='mb-0 xl:text-xl md:text-sm text-sm text-textWhite font-semibold' style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>{details?.cardName}</p>
                                            </div>
                                             <div className='flex gap-2 items-center'>
                                                <p className="md:text-xl text-lg text-textWhite font-semibold" style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>{details?.number !== null ?`XXXX XXXX XXXX ${details?.number?.substr(-4)}`: 'XXXX XXXX XXXX XXXX'}</p>
                                                {<span className={`px-2 py-1 block rounded-full text-[10px] text-textWhite badge-status badge-bg w-fit leading-none ${badge[details?.state?.toLowerCase()] || 'bg-green panding'}`} >{details?.state?.toLowerCase() == "approved" ? "Active" : details?.state}</span>}
                                            </div> 
                                            <div className=''>
                                                <p className='mb-0 text-textWhite font-normal xl:text-sm md:text-[10px] text-sm' style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>Card Owner</p>
                                                <p className='mb-0 xl:text-xl md:text-sm text-sm text-textWhite font-semibold' style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>{details?.name}</p>
                                            </div>
                                            <div className="flex justify-between">
                                            <div>
                                                 <span className="text-textWhite font-normal xl:text-sm md:text-[10px] text-sm" style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>CVV</span>
                                                 <h2 className="md:text-xl text-lg font-semibold m-0 text-textWhite md:w-44 break-words" style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>{(details?.cvv === null || details?.cvv) &&"***"}</h2>
                                              </div>
                                              <div>
                                                  <span className="text-textWhite font-normal xl:text-sm md:text-[10px] text-sm" style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>Exp.Date</span>
                                                  <h2 className="xl:text-xl md:text-sm text-sm font-semibold m-0 text-textWhite leading-none" style={{textShadow: '0px 0px 10px rgba(0, 0, 0, 0.6)'}}>{(details?.expireDate === null || details?.expireDate) && "**/**"}</h2>
                                              </div>
                                              <div></div>
                                            </div>
                                        </div>
                                        <div className='absolute bottom-3 left-6'>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='mb-4'>
                                <h4 className=' text-base text-center summary-label'>{`Card Balance : `}&nbsp; <span className='font-semibold text-lg text-whiteText'>{details?.amount} {details?.cardcurrency}</span></h4>
                            </div>
                            <div>
                           
                    <div className='block-icons'>
                        <Modal
                            className='topup-modal terminate'
                            title={<div className='flex justify-content'><span>Confirm to {actionName}</span><span className='icon close'></span></div>}
                            visible={isShowcardModal}
                            onCancel={cancelcardActions}
                        >
                            {actionsErrorMsg !== undefined && actionsErrorMsg !== null && (
                                <div className='mb-4'>
                                    <Alert
                                        className='mb-4'
                                        type="error"
                                        description={actionsErrorMsg}
                                        showIcon
                                        closable
                                    />
                                </div>
                            )}
                            <div className='text-right'>
                                <Button key="back" onClick={cancelcardActions} className='primary-btn cancel-btn'>
                                    Cancel
                                </Button>
                                <Button htmlType="submit" onClick={handlecardActions} className='primary-btn' loading={isBtnLoader}>Ok</Button>
                            </div>
                        </Modal>
                    </div>
                            </div>
                        </>}
                    <div
                        className={details?.type?.type == 'Physical' ? 'physical-bg' : 'virtual-bg'}
                    ></div>
                </div>

                <Modal className='modal-p-body'
                    title={<div className='flex justify-content'><span>Please confirm to {actionName !== "Freeze/Unfreeze" ? 'Freeze' : actionName}</span></div>}
                    visible={visible}
                    maskClosable={false}
                    onCancel={handleCancel}
                    closeIcon={
                        <Tooltip title={"Close"}><span className='icon close'></span></Tooltip>
                    }
                    footer={[
                        <Button key="back" onClick={handleCancel} className='cancel-btn'>
                            Cancel
                        </Button>,
                        <Button key="submit" type="primary" loading={loader}
                            onClick={freezCardActionHandler} className='primary-btn'>
                            OK
                        </Button>,
                    ]}
                >
                    {uploadError !== undefined && uploadError !== null && (
                        <Alert
                            type="error"
                            description={uploadError}
                            onClose={closeUploadError}
                            showIcon
                            closable message="" className='mb-2' />
                    )}
                    <div className='text-darkWhite text-base mb-3 p-3.5'>Do you really want to {details?.state == "Freezed" ? "Unfreeze" : "Freeze"}?</div>
                    <Form form={form}>
                        {details?.needSignforFreezeCard && <Form.Item name={"SignImage"} rules={[
                            validations.requiredValidator(uploadRules?.freezeSignImage ? true : false)
                        ]}>
                            <div className="flex items-center justify-content mb-1 gap-16">
                                <p className="ant-form-item-required mb-0 text-whiteText">Sign Photo<span className='text-textRedColor'> *</span> (2MB)</p>
                            </div>
                            <Upload
                                action={UPLOAD_API_END_POINT}
                                className="w-full"
                                mmultiple={false}
                                accept="image/*"
                                maxCount={1}
                                onChange={handleUploadChange(null, 'SignImage') }
                                fileList={fileLists.SignImage}
                                onRemove={handleRemove('SignImage')}
                            >
                                <Button className="bg-textshadeGray hover:bg-primaryColor dark:bg-textshadeGray hover:dark:bg-primaryColor block text-textWhite dark:text-textWhite rounded-md p-3 border border-secondaryColor hover:!border-primaryColor h-auto text-center w-full">
                                    <img src={form.getFieldsValue('SignImage').SignImage} className={`mb-1 mx-auto`} />
                                    {!form.getFieldsValue('SignImage').SignImage && <div>
                                        <img src={""} className={`upload-dark mx-auto mb-1`} />
                                        <img src={""} className={`upload-light mx-auto mb-1`} />
                                        <p className='text-textWhite text-sm max-sm:text-xs'>{`${'Drag and Drop or Browse to Choose File'}`}<span className="text-red"> *</span></p>
                                        <p className='text-placeholderColor text-xs'>PNG, JPG and JPEG files are allowed</p></div>}
                                </Button>
                            </Upload>
                        </Form.Item>}
                    </Form>
                </Modal>
                <div className="">
                    <Tabs activeKey={selectedTab} onChange={handleTabs}>
                        {tabs.map(tab => (
                            <Tabs.TabPane tab={tab.name} key={tab.key} />
                        ))}
                    </Tabs>
                </div>
                {!loader && cardId && selectedTab === '1' && <CardViewTransactionGrid showTransactions={false} screenName="Details" cardId={cardId} show={false} />}
                {!loader && selectedTab === '2' && <CardHistory cardName={details?.cardName || null} />}
                <div className='text-right mt-4'><Button type='' onClick={navigateToCards} className='primary-btn'>Back</Button></div>
            </>}
        </>
    )
}
const connectStateToProps = ({ userConfig, oidc, permissions, AdminData }) => {
    return { userConfig: userConfig?.userProfileInfo, user: oidc?.user, featurePermissions: permissions?.featurePermissions, cardactions: AdminData?.featurePermissions }
}
export default connect(connectStateToProps)(CardsDetailView)